module.exports = __webpack_public_path__ + "static/media/AU-ANU.1a101a40.png";